import { enforce, test } from "vest";
import { trans } from "@/service/i18n/i18n";
import { accessFormFieldValue, createFieldName } from "@/forms/form-field";

export function createImageFieldValidationSuite(
  definition: ImageField,
  formValue: any,
): void {
  const value = accessFormFieldValue(definition, formValue) as string;

  if (definition.required) {
    test(
      createFieldName(definition),
      trans("form_validation.image.required"),
      () => {
        enforce(value).isNotEmpty();
      },
    );
  }
}
